export default "__VITE_ASSET__qxTznj6M__"